<template>
    <v-app>
        <v-container fluid>
            <v-row >
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                                Others Info
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submitForm(currentStatus)"
                                ref="addPurOrder"
                                id="addPurOrder"
                                >
                                    <v-row class="pa-2">
                                        <v-col cols="12">
                                            <v-date-input
                                            input-format="dd/mm/yyyy"
                                            label="Payment Date"
                                            density="compact"
                                            prepend-icon=""
                                            prepend-inner-icon="mdi-calendar"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="payment_date.value.value"
                                            :error-messages="payment_date.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            >
                                                <template #label>
                                                    Payment Date
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-date-input>

                                            <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="payment_method.value.value"
                                            :items="getPaymentMethodList"
                                            :item-title="(item) => `${item.title}`"
                                            item-value="value"
                                            :error-messages="payment_method.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            >
                                                <template #label>
                                                Payment Method
                                                <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                            v-if="payment_method.value.value"
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="payment_account_head_id.value.value"
                                            :items="getAccountHeadList"
                                            :item-title="(item) => `${item.name}`"
                                            item-value="id"
                                            :error-messages="payment_account_head_id.errorMessage.value"
                                            autocomplete="off"
                                            :loading="paymentAccountHeadLoading"
                                            clearable
                                            >
                                                <template #label>
                                                    Payment Account Head
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                            label="Year"
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="year.value.value"
                                            :items="getYearsList"
                                            item-value="value"
                                            :error-messages="year.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            >
                                                <template #label>
                                                    Year
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="month.value.value"
                                            :items="getMonthsList"
                                            :item-title="(item)=> item.title"
                                            item-value="value"
                                            :error-messages="month.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            >
                                                <template #label>
                                                    Month
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                            v-if="year.value.value && month.value.value"
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="salary_process_master_id.value.value"
                                            :items="getSalaryProcessMasterList"
                                            :item-title="(item) => `${item.code}`"
                                            item-value="id"
                                            :error-messages="salary_process_master_id.errorMessage.value"
                                            @update:modelValue="onSalaryProcessChange"
                                            autocomplete="off"
                                            :loading="salaryProcessMasterLoading"
                                            clearable
                                            >
                                                <template #label>
                                                    Salary Process
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header">
                                Item Info
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submitForm(currentStatus)"
                                ref="addPurOrder"
                                id="addPurOrder"
                                >

                                <v-row class="pt-0">
                                    <v-col cols="12">
                                        <v-table
                                        density="compact"
                                        :loading="loading"
                                        fixed-header
                                        class="table-dotted-border-bottom"
                                        >
                                            <!-- style="height:40vh; overflow-y: scroll;" -->
                                            <thead>
                                                <tr>
                                                    <th class="text-center" style="width: 5%">SL</th>
                                                    <th class="text-left" style="width: 25%">Employee Code</th>
                                                    <th class="text-left" style="width: 25%">Employee Name</th>
                                                    <th class="text-left" style="width: 25%">Employee Designation</th>
                                                    <th class="text-right" style="width: 10%">Net Payable</th>
                                                    <th class="text-center" style="width: 10%">Paid</th>
                                                    <th class="text-right" style="width: 15%">Remaining Salary</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr
                                                v-for="(item, index) in cart"
                                                v-if="cart.length > 0"
                                                :key="index"
                                                >
                                                    <td class="text-center py-1">{{ index + 1 }}</td>

                                                    <td
                                                    class="text-left py-1"
                                                    style="white-space: normal"
                                                    >
                                                        {{ item.employee_code }}
                                                    </td>

                                                    <td
                                                    class="text-left py-1"
                                                    style="white-space: normal"
                                                    >
                                                        {{ item.employe_name }}
                                                    </td>

                                                    <td
                                                    class="text-left py-1"
                                                    style="white-space: normal"
                                                    >
                                                        {{ item.employee_designation }}
                                                    </td>

                                                    <td
                                                    class="text-right py-1"
                                                    style="white-space: normal"
                                                    >
                                                        {{ item.net_payable }}
                                                    </td>

                                                    <td class="text-right py-2">
                                                        <v-text-field
                                                            style="width: 150px"
                                                            :min="1"
                                                            type="number"
                                                            density="compact"
                                                            variant="outlined"
                                                            bg-color="grey-lighten-4"
                                                            v-model.number="item.paid"
                                                            hide-details="auto"
                                                            :error="item.paid < 1 || item.paid > item.remaining_amount"
                                                            :error-messages="getPaidErrors(item)"
                                                        ></v-text-field>
                                                    </td>

                                                    <td
                                                    class="text-right py-1"
                                                    style="white-space: normal"
                                                    >
                                                        {{ item.remaining_amount }}
                                                    </td>
                                                </tr>
                                                <tr v-else>
                                                    <td colspan="6" class="text-center text-red">
                                                        You have no item
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </v-table>
                                    </v-col>
                                </v-row>

                                <!-- Close Cart Table -->

                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-row class="pt-2">
                                        <v-col cols="12">
                                            <v-layout class="justify-end">
                                            <v-btn
                                                class="bg-grey-darken-1 me-2"
                                                variant="flat"
                                                @click="submitForm('draft')"
                                                >DRAFT</v-btn
                                            >
                                            <v-btn
                                                class="bg-primary"
                                                variant="flat"
                                                @click="submitForm('confirmed')"
                                                >Confirm</v-btn
                                            >
                                            </v-layout>
                                        </v-col>
                                    </v-row>
                                </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import formattedDate from "@/plugins/dateFormatter";
import { useField, useForm } from "vee-validate";
import { getCurrentInstance, ref } from "vue";
import { useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";
import * as yup from "yup";
export default {
    components: {},
    data: () => ({
        panel: [0],
        panel2: [0],

        accountHeads: [],
        salaryProcessMaster: [],
        paymentMethods: [
            { title: "Cash", value: "CASH" },
            { title: "Bank", value: "BANK" },
            { title: "Mobile Banking", value: "MOBILE_BANKING" },
        ],
        years: [],
        months: [
            { title: "January", value: 1 },
            { title: "February", value: 2 },
            { title: "March", value: 3 },
            { title: "April", value: 4 },
            { title: "May", value: 5 },
            { title: "June", value: 6 },
            { title: "July", value: 7 },
            { title: "August", value: 8 },
            { title: "September", value: 9 },
            { title: "October", value: 10 },
            { title: "November", value: 11 },
            { title: "December", value: 12 },
        ],
        cart: [],

        paymentAccountHeadLoading: false,
        salaryProcessMasterLoading: false,

        errorMessages: "",
        visible: false,
        search: "",
    }),
    watch: {
        "month.value.value"(val) {
            if (!this.year.value.value && !val) {
                this.salaryProcessMaster = [];
                return;
            }   
            this.salaryProcessMasterLoading = true;         
            this.$store.dispatch('salaryProcess/getSalaryProcessList', {
                month: val,
                year: this.year.value.value
            }).then((res) => {
                this.salaryProcessMaster = res.data || [];
                this.salaryProcessMasterLoading = false;
            });
            
            
        },
        "year.value.value"(val) {
            if (!this.month.value.value && !val) {
                this.salaryProcessMaster = [];
                return;
            }
            this.salaryProcessMasterLoading = true;
            this.$store.dispatch('salaryProcess/getSalaryProcessList', {
                year: val,
                month: this.month.value.value
            }).then((res) => {
                this.salaryProcessMaster = res.data || [];
                this.salaryProcessMasterLoading = false;
            });
            
        },
        "payment_method.value.value"(val) {
            this.paymentAccountHeadLoading = true;
            this.$store.dispatch('getPaymentAccountHeads', {
                payment_method: val
            }).then((res) => {
                this.accountHeads = res.data;
                this.paymentAccountHeadLoading = false;
            });
        },
    },
    created() {
        if (this.$store.getters.getWarehouseList.length === 0) {
            this.$store.dispatch("getWarehouseList");
        }
        if (this.$store.getters.getSupplierList.length === 0) {
            this.$store.dispatch("getSupplierList");
        }
        if (this.$store.getters.getProductMapList.length === 0) {
            this.$store.dispatch("getProductMapList");
        }
        if (this.$store.getters.getPurRequisitionList.length === 0) {
            this.$store.dispatch("getPurRequisitionList");
        }
    },
    computed: {

        getPaymentMethodList() {
            return this.paymentMethods;
        },
        getAccountHeadList() {
            return this.accountHeads;
        },
        getYearsList() {
            const startYear = 2025;
            const currentYear = new Date().getFullYear();

            for (let y = startYear; y <= currentYear; y++) {
                this.years.push(y);
            }

            return this.years;
        },
        getMonthsList() {
            return this.months;
        },
        getSalaryProcessMasterList() {
            return this.salaryProcessMaster;
        },

        branchId() {
            return this.$store.getters.getAuthUser.branch_id || null;
        },
        getWarehouseList() {
            return this.$store.getters.getWarehouseList;
        },
        getProductMapList() {
            let products = this.$store.getters.getProductMapList;
            return products.filter(
                (item) => item.branch_id == this.branchId && item.status == 1
            );
        },
        getSupplierList() {
            return this.$store.getters.getSupplierList;
        },
        filteredPurRequisitionList() {
            const requisitions = this.$store.getters.getPurRequisitionList || [];
            return requisitions.filter(
                (item) => item.branch_id == this.branchId && item.status == 1
            );
        },
    },
    methods: {
        async onSalaryProcessChange(selectedId) {
            if (!selectedId) {
                this.cart = [];
                return;
            }

            try {
                this.$store.commit("SET_LOADING", { color: "primary" });
                
                const res = await this.$store.dispatch('salaryProcess/getSalaryProcessById', selectedId);
                const data = res.data || {};
                this.cart = [];
                (data.details || []).forEach((item) => {
                    this.cart.push({
                        salary_process_detail_id: item.id,
                        employe_name: item.employee.name,
                        employee_code: item.employee.code,
                        employee_designation: item.designation.name,
                        employee_id: item.employee_id,
                        net_payable: item.net_payable,
                        paid: item.paid,
                        remaining_amount: item.remaining_amount,
                    });
                });
                
                this.$store.commit("UNSET_LOADING");
            } catch (error) {
                console.error("Failed to load salary process data:", error);
            }
        },
        getPaidErrors(item) {
            const errors = [];

            if (item.paid < 1) {
                errors.push("Paid Amount must be greater than 0");
            }
            if (item.paid > item.remaining_amount) {
                errors.push("Paid Amount must be lesser or equal to Remaining Salary");
            }

            return errors;
        }
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                payment_date: yup.string().required().label("Payment Date"),
                payment_method: yup.string().required().label("Payment Date"),
                payment_account_head_id: yup.number().required().label("Payment Date"),
                month: yup.number().required().label("Payment Date"),
                year: yup.number().required().label("Payment Date"),
                salary_process_master_id: yup.string().required().label("Payment Date"),
            }),
        });

        const payment_date = useField("payment_date");
        const payment_method = useField("payment_method");
        const payment_account_head_id = useField("payment_account_head_id");
        const payment_status = useField("payment_status");
        const salary_process_master_id = useField('salary_process_master_id');
        const month = useField("month");
        const year = useField("year");
        
        const remarks = useField("remarks");
        
        const errorMessages = ref("");
        const cart = ref([]);
        const loading = ref("");
        const buttonText = ref("");
        buttonText.value = "Save";
        const store = useStore();
        const router = useRouter();

        const currentStatus = ref("");

        const submitForm = (status) => {
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => {
            values.payment_status = currentStatus.value;
            values.cart = cart.value;
            store
                .dispatch("saveUpdateSalaryPayment", values)
                .then((response) => {
                    resetForm();
                    buttonText.value = "Save";
                    cart.value = [];
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    store.dispatch('getSalaryPaymentList');
                    setTimeout(() => {
                        router.push({ name: "payment-order-list" });
                    }, 2000);
                })
                .catch((error) => {
                    toast.error(error.response.data.message);
                });
        });

        return {
            submitForm,
            submit,
            payment_date,
            payment_method,
            payment_account_head_id,
            payment_status,
            month,
            year,
            salary_process_master_id,
            remarks,
            cart,
            errorMessages,
            buttonText,
            loading,
        };
    },

    mounted() {
        // this.employee_id.value.value = "";
        // let user = this.$store.getters.getAuthUser;
        // this.purOrder_by.value.value = user.full_name;
        // this.purOrder_by_mobile.value.value = user.mobile;
        // this.purOrder_by_email.value.value = user.email;

        // const queryId = this.$route.query.id;
        // const paramsId = this.$route.params.id;

        // // Only auto-load requisition when an id is present
        // if (paramsId) {
        //     // set the requisition_master_id field so validation and form reflect the selection
        //     this.requisition_master_id.value.value = paramsId;
        //     this.onRequisitionChange(paramsId);
        // }


        
        // if (queryId) {
        // // when id present on route, auto-load the requisition details into the form/cart
        // // use the existing handler to populate warehouse, remarks and cart
        

        // this.$nextTick(() => {
        //     this.$store
        //     .dispatch("getPurOrderById", id)
        //     .then((data) => {
        //         this.isEntryMode = false;
        //         let purOrder = data;
        //         this.pur_order_master_id.value.value = purOrder.id;
        //         this.purchase_date.value.value = purOrder.purchase_date
        //             ? new Date(purOrder.purchase_date)
        //             : new Date();
        //         this.shipping_date.value.value = purOrder.shipping_date
        //             ? new Date(purOrder.shipping_date)
        //             : new Date();
        //         this.purchase_type.value.value = parseInt(purOrder.purchase_type);
        //         this.warehouse_id.value.value = purOrder.warehouse.id;
        //         this.requisition_master_id.value.value = purOrder.requisition.id;
        //         this.product_id.value.value = null;
        //         this.supplier_id.value.value = purOrder.supplier.id;
        //         this.cart.value = [];

        //         // Insert items one by one
        //         (purOrder.pur_order_details || []).forEach((item) => {
        //                 this.cart.push({
        //                     product_id: item.product_id,
        //                     product_name: item.product?.name || "",
        //                     qty: item.qty,
        //                     unit_id: item.product.unit?.id || "",
        //                     unit_name: item.product.unit?.name || "",
        //                     rate: item.rate,
        //                     total: item.qty * item.rate,
        //                 });
        //             });
        //             this.remarks.value.value = purOrder.remarks ? purOrder.remarks : "";
        //             this.$store.commit("UNSET_LOADING");
        //         })
        //         .catch((error) => {
        //             this.$store.commit("UNSET_LOADING");
        //             console.error("Failed to fetch rfq:", error);
        //         });
        //     });
        // } else {
        // this.pur_order_master_id.value.value = "";
        // this.purchase_date.value.value = new Date();
        // this.shipping_date.value.value = new Date();
        // this.isEntryMode = true;
        // }
    },
};
</script>
